import { mainWrapper2zn16bcxq7094 as main } from './Coupling-client/com/zegreatrob/coupling/client/Main.mjs';
import './ktor-ktor-client-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
main();

//# sourceMappingURL=Coupling-client.mjs.map
